export const translateWithParams = (text: string, params: {[key: string]: string | number}) => {
  let translatedText = text;

  Object.keys(params).map(key => {
    const toReplace = `%${key}%`;
    translatedText = translatedText.replace(toReplace, `${params[key]}`)
  })

  return translatedText;
}